<template>
  <!--商城  创建 spu-->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col>
            <el-form-item label="商品名称" prop="goodsName">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.goodsName"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="原价" prop="oldPrice">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.oldPrice"
                type="number"
                id="number"
                clearable
                oninput="value=value.replace('-', '')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="实际售价" prop="price">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.price"
                type="number"
                min="1"
                id="number"
                clearable
                oninput="value=value.replace('-', '')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="封面图（700*700）"
              prop="coverUrl"
              ref="coverUrl"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="toAdDas.coverUrl"
                  :src="toAdDas.coverUrl"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品类别" prop="scTypeId">
              <el-cascader
                v-model="value"
                :options="options"
                @change="handleChange"
              ></el-cascader>
              <!-- <el-cascader
                :options="options"
                v-model="value"
                @change="handleChange"
                style="width: 300px"
              ></el-cascader> -->
              <!-- <el-select
                v-model="toAdDas.scTypeId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="商品说明" prop="goodsDesc">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.goodsDesc"
                clearable
                :rows="4"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否推荐" prop="isRecommend">
              <el-checkbox v-model="toAdDas.isRecommend"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="客服编号" prop="customerNumber">
              <!-- <el-input
                placeholder="请输入内容"
                v-model="toAdDas.customerNumber"
                clearable
              /> -->
              <el-select
                v-model="toAdDas.customerNumber"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            style="margin-left: 200px; margin-top: 50px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["AddData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.coverUrl)
      if (this.toAdDas.coverUrl == "") {
        callback(new Error("封面图不能为空"));
      } else {
        callback("");
      }
    };
    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      options: [],
      options2:[
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
        {
          value: "6",
          label: "6",
        },
        {
          value: "7",
          label: "7",
        },
        {
          value: "8",
          label: "8",
        },
        {
          value: "9",
          label: "9",
        },
        {
          value: "10",
          label: "10",
        },
      ],
      value: [],
      //添加的参数：
      toAdDas: {
        goodsName: "", // 商品名称
        price: "", //实际售价
        coverUrl: "", //封面图
        oldPrice: "", //原价
        scTypeId: "", //商品类别
        goodsDesc: "", //商品说明
        isRecommend: false,
        customerNumber: "", //客服编号
      },

      toAdRule: {
        goodsName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        price: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        customerNumber: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        oldPrice: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        scTypeId: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        goodsDesc: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //新增：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var id = this.toAdDas.scTypeId.pop();
          this.postAxios("/goods/spu/insert", {
            goodsName: this.toAdDas.goodsName, //商品名称
            coverUrl: this.toAdDas.coverUrl, //封面图
            price: this.toAdDas.price, //售价
            oldPrice: this.toAdDas.oldPrice, //实际售价
            isRecommend: Number(this.toAdDas.isRecommend), //是否推荐
            scTypeId: id, //商品类别
            goodsDesc: this.toAdDas.goodsDesc, //商品说明
            customerNumber: this.toAdDas.customerNumber, //客服编号
          }).then((res) => {
            if (res.success == true) {
              this.$router.push({ path: "/shoppingMall" });
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    handleChange(value) {
      this.toAdDas.scTypeId = value;
      // var id = value.pop();
      // this.toAdDas.scTypeId = id;
      // console.log(id, "idididi");
      // console.log(this.toAdDas.scTypeId, "this.toAdDas.scTypeId");
    },
    // 头像上传成功
    upSuccess(file) {
      this.toAdDas.coverUrl = file.entity;
    },
    getList() {
      this.getAxios("/scType/list").then((res) => {
        this.list = res.content;
        res.content.map((i, ind) => {
          this.options.push({
            label: i.typeName,
            value: i.id,
            children: [],
          });
          i.childList.map((x, y) => {
            if (x.childList.length == 0) {
              this.options[ind].children.push({
                label: x.typeName,
                value: x.id,
              });
            } else {
              this.options[ind].children.push({
                label: x.typeName,
                value: x.id,
                children: [],
              });
            }

            if (i.childList[y].childList != []) {
              i.childList[y].childList.map((n) => {
                this.options[ind].children[y].children.push({
                  label: n.typeName,
                  value: n.id,
                });
              });
            }
          });
        });
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>